import { uniqBy } from 'lodash';
import { fromJsonArray, fromJsonArrayWith } from 'src/core/utils';
import SelectedProduct from 'src/entities/cart/request/SelectedProduct';
import CustomFieldOrderProduct from 'src/entities/cart/response/CustomFieldOrderProduct';
import { DIVERS_ARTICLE_GROUP } from 'src/entities/products/Product';

export default class OrderProduct {
    ffProductNumber: string;
    localizedName: string;
    articleGroupNormalizedName: string;
    articleGroupLocalizedName: string;
    quantity: number;
    colli: number;
    colliEntity: string;
    vat: number;
    gross: boolean;
    totalGrossPrice: number;
    grossPrice: number;
    totalNettPrice: number;
    nettPrice: number;
    currencyIso: string;
    customFields: CustomFieldOrderProduct[];
    childProducts: OrderProduct[];
    chosenVariants: SelectedProduct[];
    specialDeliveryInfo?: string;
    vendorId: number;

    constructor(json: any) {
        this.ffProductNumber = json.ffProductNumber.toString();
        this.localizedName = json.localizedName;
        this.articleGroupNormalizedName = json.articleGroupNormalizedName;
        this.articleGroupLocalizedName = json.articleGroupLocalizedName;
        this.quantity = json.quantity ? Number(json.quantity) : json.quantity;
        this.colli = json.colli;
        this.colliEntity = json.colliEntity;
        this.vat = json.vat;
        this.gross = json.gross;
        this.totalGrossPrice = json.totalGrossPrice;
        this.grossPrice = json.grossPrice;
        this.totalNettPrice = json.totalNettPrice;
        this.nettPrice = json.nettPrice;
        this.currencyIso = json.currencyIso4217 || json.currencyIso;
        this.customFields = fromJsonArray(CustomFieldOrderProduct, json.customFields);
        this.childProducts = fromJsonArray(OrderProduct, json.childProducts);
        this.chosenVariants = fromJsonArrayWith(SelectedProduct.fromJson, json.chosenVariants);
        this.specialDeliveryInfo = json.specialDeliveryInfo;
        this.vendorId = json.vendorId;
    }

    public hasUnfinishedCustomFields(): boolean {
        return this.customFields.some(field => field.value == null);
    }

    public get price(): number {
        return this.gross ? this.grossPrice : this.nettPrice;
    }

    public get totalPrice(): number {
        return this.gross ? this.totalGrossPrice : this.totalNettPrice;
    }

    isDiversProduct(): boolean {
        return this.articleGroupNormalizedName === DIVERS_ARTICLE_GROUP;
    }

    /**
     * Returns only unique child products and calculates the appropriate quantity for each unique product
     */
    public get uniqueChildProducts(): OrderProduct[] {
        return uniqBy(this.childProducts, p => `${p.ffProductNumber}_${p.vendorId}`).map((product: OrderProduct) => {
            const quantity = product.quantity === 1 ? 1 : product.quantity / this.quantity;
            return new OrderProduct({
                ...product,
                quantity,
            });
        });
    }
}
